<template>
  <v-dialog v-model="fullscreen.dialog" fullscreen transition="dialog-bottom-transition" :overlay="false">                
    <v-card>
      <v-toolbar dark :color="color">
        <v-btn icon @click.native="fullscreen.dialog = false" dark>
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Settings</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark flat @click.native="basic.dialog = true; isUpdate = false; formModel = {}">NEW SETUP</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      
      <v-list two-line class="pa-0">    
        <v-subheader>General</v-subheader> 
        <v-list-tile avatar v-for="(item, index) in settings" :key="'index'+index" >
          <v-list-tile-action v-if="item.value == 'true' || item.value == 'false' || item.value == true || item.value == false">
            <v-checkbox v-model="item.value" @change="save(true, item)"></v-checkbox>
          </v-list-tile-action>  
          <v-list-tile-avatar v-if="item.icon" @click="handleClick(item)">
            <v-icon :class="[item.color] +' white--text'">{{ item.icon }}</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content @click="handleClick(item)">
            <v-list-tile-title>{{ item.title?item.title:item.key }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ item.content?item.content:item.value }}</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>            
            <v-btn icon ripple @click="handleClick(item)">
              <v-icon color="grey lighten-1">info</v-icon>
            </v-btn>
            
          </v-list-tile-action>
        </v-list-tile>        
      </v-list>
      <v-divider></v-divider> 
      
    </v-card>
    <v-dialog v-model="basic.dialog" persistent max-width="500px">        
        <v-card>
          <v-card-title>
            <span class="headline">Setting Data</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <v-text-field v-model="formModel.key" label="Key *" hint="key is required" required></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="formModel.value" label="Value *" hint="value of key" required></v-text-field>
                </v-flex>
                <!--<v-flex xs12 sm6>
                  <v-text-field v-model="formModel.title" label="Title *" hint="title to show" required></v-text-field>
                </v-flex>
                <v-flex xs12 sm12>
                  <v-text-field v-model="formModel.content" label="Text View" hint="example of helper text"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="formModel.icon" label="Icon" required></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="formModel.color" label="Color"></v-text-field>
                </v-flex>-->                                      
                <small>*indicates required field</small>                
              </v-layout>
            </v-container>            
          </v-card-text>
          <v-card-actions>
            <v-btn v-if="isUpdate" icon ripple @click="remove()">
              <v-icon color="error">delete</v-icon>
            </v-btn>    
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="basic.dialog = false">Close</v-btn>
            <v-btn color="blue darken-1" flat @click="save(isUpdate)">{{isUpdate ? 'Update':'Save'}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>  
  </v-dialog>    
</template>


<script>
import conf     from '@/config';  
import config   from '@/apps/main/Setting';    
import Settings from '@/util/models/Settings';     
import moment   from 'moment';

const model = new Settings();
    
export default {
  name: 'widget-dialog-setting',    
  data () {
    return {
      color:conf.color,
        isUpdate : false,
        formModel:{
            id : null,
            key : null,
            value : null,
            title : null,
            content : null,
            icon : null,
            color : null,
        },        
        saveModel:{
            id : null,
            key : null,
            value : null,
            title : null,
            content : null,
            icon : null,
            color : null,
        },
        basic: {
            dialog: false
        },
        fullscreen: {
            dialog: false,
            notifications: false,
            sound: true,
            widgets: false        
        },
        scrollable: {
            name: '',
            dialog: false        
        },  
        items: [],
        settings: [],
        folders: [
            { icon: 'folder', iconClass: 'grey lighten-1 white--text', title: 'Photos', subtitle: 'Jan 9, 2014' },
            { icon: 'folder', iconClass: 'grey lighten-1 white--text', title: 'Recipes', subtitle: 'Jan 17, 2014' },
            { icon: 'folder', iconClass: 'grey lighten-1 white--text', title: 'Work', subtitle: 'Jan 28, 2014' }
        ],
        files: [
            { icon: 'assignment', iconClass: 'blue white--text', title: 'Vacation itinerary', subtitle: 'Jan 20, 2014' },
            { icon: 'call_to_action', iconClass: 'amber white--text', title: 'Kitchen remodel', subtitle: 'Jan 10, 2014' }
        ]
    };
  },
  
  created () {    
    var context = this;
        
    context.$store.watch(
        function (state) {
            return state;
        },
        function () {
            context.init(); 
        },
        {deep: true}
    );  
      
    window.getApp.$on('APP_OPEN_DIALOG_SETTING', () => {
        //this.getNotif();
        this.fullscreen.dialog = true;      
    });  
    
    this.importConfig();
  },
  
  mounted() {
     this.init();   
  },
  
  computed: {
      
  },  
  
  methods: {
    init(){        
        model.all().then(data => {            
            this.settings = data;              
        });
    },  
      
    async importConfig(){        
        for(var i in config){
            Object.assign(this.saveModel, config[i]);                                                                                       
            var data = model.key(config[i].key);             
            if(!data && !config[i].secure){                
                model.create(this.saveModel);                 
            }                        
        }        
    },  
      
    openfull(){
        this.fullscreen.dialog = true;
    },
    
    getNotif(){        
        //window.getApp.$store.dispatch('entities/notifications/insert', {data : this.data});
        var notifs = window.getApp.$store.getters['entities/notifications/query']().orderBy('id', 'desc').limit(4).get();
        this.items = notifs;
    },
    
    handleClick(item) {
        if(item){
            this.isUpdate = true;
            Object.assign(this.formModel, item);
            this.basic.dialog = true;
        }
    },
    
    format(time){
        return moment(time).format('ddd, DD MMMM YYYY, HH:mm:ss');
    },
    
    remove(){
        this.$swal({
                title: 'Are you sure?', text: "You won't be able to revert this!",  type: 'warning',
                showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
        }).then((result) => {                 
            if (result.value) {                    
                model.delete({id:this.formModel.id, flag:'permanen'}).then( res => {
                    if(res.status === 200){                   
                        this.$swal({ type: 'warning', title: 'Your file has been deleted.', showConfirmButton: false, timer: 1000});       
                        this.init();
                        this.basic.dialog = false;
                    } else {
                        var title = res.status ? '#'+res.status + ' Oops...' : 'Oops...';
                        var text  = res.statusText ? res.statusText:
                            'Something happened in setting up the request that triggered an Error.'; 
                        this.$swal({type: 'error', title: title, text: text});                                        
                    }
                });                
            }
        });
    },
    
    async save(isUpdate = false, item = null) {                
        this.$validator.validateAll();   
        if(item){
            Object.assign(this.formModel, item);
        }
        this.formModel.time = moment().valueOf();
        this.formModel.info = null;
        if( !this.errors.any() ) {
            var res = isUpdate ? await model.update(this.formModel): await model.create(this.formModel);                
            if(res.status == 200){   
                if(!item){
                    this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000})
                }
                this.init();
                this.basic.dialog = false;                    
            } else {
                var title = res.status ? '#'+res.status + ' Oops...' : 'Oops...';
                var text  = res.statusText ? res.statusText: 'Something happened in setting up the request that triggered an Error.';                     
                if(res.data){ if(res.data.message){ text += ' ' + res.data.message } else {this.validate(res.data)}}                                
                this.$swal({type: 'error', title: title, text: text});
            }
        }             
    },
    
    
    
  }
};
</script>
